
import { WorldCountry } from '../types';
import { southKoreaExpanded } from './southKoreaExpansion';

export const southKoreaExpansion2: WorldCountry[] = [
  southKoreaExpanded
];
